import React from "react";

import styled from "styled-components";

import * as Typography from "./Typography";
import { isRBEAuthor } from "../utils/functional";

const AnsweresRow = ({ description, timestamp, author }) => {
  const date = new Date(parseInt(timestamp));
  return (
    <ProtocolInfo
      key={timestamp}
      style={{
        borderBottom: "1px solid rgba(34, 34, 34,0.1)",
      }}
    >
      <ProtocolColumn
        style={{
          flex: 1,
          backgroundColor: isRBEAuthor(author)
            ? "rgba(0, 0, 0,0.06)"
            : "#fafafa",
        }}
      >
        <Typography.span padding="0 0 5px 0" weight="600">
          {author}
        </Typography.span>
        <Typography.span padding="0px">{date.toLocaleString()}</Typography.span>
      </ProtocolColumn>
      <ProtocolColumn
        style={{
          flex: 4,
          backgroundColor: isRBEAuthor(author)
            ? "rgba(0, 0, 0,0.04)"
            : "#fffff",
        }}
      >
        <Typography.span>{description}</Typography.span>
      </ProtocolColumn>
    </ProtocolInfo>
  );
};

const ProtocolInfo = styled.div`
  display: flex;
  flex-direction: row;
`;

const ProtocolColumn = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column wrap;
  padding: 15px;
`;

export default AnsweresRow;
